export default __webpack_public_path__ + "c7649f91855f0cc61ac3990b3ff8c1f4.png";